import { FrameworkConfiguration } from 'aurelia-framework';
import { Language } from '../../models/localization/language';

export abstract class LocalizationProvider {
    public abstract async getLanguages(): Promise<Language[]>;
    public abstract async setLocale(languageId: string): Promise<void>;
    public abstract async getLocale(): Promise<string>;
    public abstract translate(key: string, fallback?: string): string
    public abstract async init(config: FrameworkConfiguration): Promise<void>;
}